import { useNavigate, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import StructuredData from '@/components/base/StructuredData';

const SITE_URL = 'https://sugargoosheet.bar';

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Privacy Policy',
  url: SITE_URL + '/privacy-policy',
  description: 'Privacy Policy for Sugargoo Sheet — learn how we handle information, cookies, third-party links, and your data rights.',
  publisher: { '@type': 'Organization', name: 'Sugargoo Sheet' },
};

export default function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background-50">
      <StructuredData data={webPageSchema} />
      <Navbar />
      <main>
        <div className="pt-24 pb-10 md:pt-28 md:pb-14">
          <div className="max-w-3xl mx-auto px-6 md:px-10">
            <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-6 flex-wrap" aria-label="Breadcrumb">
              <a href="/" className="hover:text-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap" onClick={(e) => { e.preventDefault(); navigate('/'); }}>
                Home
              </a>
              <i className="ri-arrow-right-s-line w-3 h-3 flex items-center justify-center"></i>
              <span className="text-foreground-400 whitespace-nowrap">Privacy Policy</span>
            </nav>

            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-8">Privacy Policy</h1>
            <p className="text-sm text-foreground-600 mb-4">Last updated: August 2026</p>

            <div className="space-y-6 text-sm md:text-base text-foreground-700 leading-relaxed">
              <section>
                <h2 className="font-heading text-xl font-semibold text-foreground-900 mb-3">1. Information We Collect</h2>
                <p>Sugargoo Sheet does not collect personal information directly. As an informational resource website, we do not require user registration, do not store user accounts, and do not process payments. Any interactions with external links, including our main website at kaspreadsheet.com, are governed by their respective privacy policies.</p>
              </section>

              <section>
                <h2 className="font-heading text-xl font-semibold text-foreground-900 mb-3">2. Cookies and Tracking</h2>
                <p>Our website may use essential cookies necessary for proper website functioning. We do not use tracking cookies for advertising purposes or sell any user data to third parties. You can control cookie settings through your browser preferences at any time.</p>
              </section>

              <section>
                <h2 className="font-heading text-xl font-semibold text-foreground-900 mb-3">3. Third-Party Links</h2>
                <p>Our website contains links to external websites, including kaspreadsheet.com. We are not responsible for the privacy practices or content of these external sites. We encourage you to review the privacy policies of any website you visit through our links.</p>
              </section>

              <section>
                <h2 className="font-heading text-xl font-semibold text-foreground-900 mb-3">4. Contact</h2>
                <p>If you have questions about this Privacy Policy, please visit our main website at kaspreadsheet.com for contact information.</p>
              </section>
            </div>

            <div className="mt-10 pt-8 border-t border-background-200">
              <div className="flex flex-wrap gap-2">
                <Link to="/" className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg bg-background-100 text-xs font-medium text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-all duration-200 cursor-pointer whitespace-nowrap">
                  <i className="ri-home-line w-3.5 h-3.5 flex items-center justify-center"></i>
                  Home
                </Link>
                <Link to="/sugargoo-spreadsheet-guide" className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg bg-background-100 text-xs font-medium text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-all duration-200 cursor-pointer whitespace-nowrap">
                  Spreadsheet Guide
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}